import * as types from '../actions/types';


const INITIAL_STATE={
    levels: [],
    id: undefined,
    success: ''
}

export default (state=INITIAL_STATE, action) => {
    switch(action.type){
        case types.FETCH_TENANTINDUSTRY_LEVELS_SUCCESS:
            return {
                levels: action.payload,
            }
        default:
        return state;
    }  
};